module.exports = __webpack_public_path__ + "files/613f77c05ade216eb470a3c1c2e208e0.png";